export default __webpack_public_path__ + "static/media/home.95ab4605.svg";